import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {Loading} from './Common';

// Account sessions are first-party on the configured API origin. This avoids
// relying on third-party cookies when a deployment also has a secondary hostname.
export const AccountOrigin = ({children}) => {
  const location = useLocation();
  const accountBase = new URL(process.env.REACT_APP_BACKEND_URL);
  const needsNavigation = accountBase.origin !== window.location.origin;
  const accountPath = location.pathname + location.search;
  useEffect(() => {
    if (needsNavigation) window.location.replace(new URL(accountPath, accountBase.origin).href);
  }, [needsNavigation, accountPath, accountBase.origin]);
  return needsNavigation ? <Loading/> : children;
};